export default __webpack_public_path__ + "static/media/placeholder_dummy2016-ferienwohnung01-de.de88d6e6.png";